var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 210 210",
    width: 400,
    height: 400,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path 0",
    className: "shp0",
    d: "M129.18,10.5l1.95,2.5c1.51,1.93 1.94,4.03 1.87,16h7c3.85,0 8.46,0.6 10.25,1.34c1.79,0.74 4.71,2.99 6.5,5c1.79,2.01 3.49,5.12 3.79,6.91c0.3,1.79 0.41,35.24 -0.04,145.41l-3,3.86c-1.65,2.12 -4.8,4.67 -7,5.65c-3.64,1.62 -7.83,1.79 -46,1.79c-38.72,0 -42.31,-0.14 -46,-1.85c-2.2,-1.02 -4.98,-2.92 -6.18,-4.23c-1.2,-1.31 -2.66,-3.62 -3.25,-5.13c-0.72,-1.86 -1.07,-25.99 -1.07,-74.25c0,-59.58 0.24,-71.96 1.41,-74.25c0.78,-1.51 2.69,-3.96 4.25,-5.44c1.56,-1.48 4.08,-3.17 5.59,-3.75c1.51,-0.58 5.9,-1.06 16.75,-1.06v-6.5c0,-3.58 0.54,-7.43 1.21,-8.56c0.66,-1.13 2.13,-2.46 3.25,-2.96c1.12,-0.5 12.55,-0.81 48.72,-0.48zM96,39.5v9.5h-28v102h73v-102h-28v-19h-17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.2da570c6e323a5d084f243d584ef49c5.svg";
export { ForwardRef as ReactComponent };